import { FC, useEffect } from 'react';

import { Assets } from '@assets';
import { ModalBodyContainer } from '@components';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { useBoostDetailsStore } from '@store';
import { sendAnalyticsEvent } from '@utils';

export interface EMCRedeclareModalProps {
  primaryAction: () => void;
  secondaryAction: () => void;
}

export const EMCRedeclare: FC<EMCRedeclareModalProps> = ({ primaryAction, secondaryAction }) => {
  const emcDeclaring = useBoostDetailsStore(state => state.emcDeclaring);

  const handleRedeclare = () => {
    primaryAction();
    sendAnalyticsEvent('Medical cover declined', {
      TravellerID: emcDeclaring?.travellerId ?? '',
    });
  };

  useEffect(() => {
    sendAnalyticsEvent('Decline cover modal opened', {
      TravellerID: emcDeclaring?.travellerId ?? '',
    });
  }, [emcDeclaring?.travellerId]);

  return (
    <ModalBodyContainer
      icon={<Assets.AlertOutline />}
      header={<Text variant="h3-28/sb">{i18n.t('emcShared.global.modal.redeclare.title')}</Text>}
      description={
        <Text variant="body-16/r">{i18n.t('emcShared.global.modal.redeclare.description')}</Text>
      }
      buttons={
        <div className="flex flex-col w-full md:flex-row my-2 gap-4">
          <Button
            variant="secondary"
            onClick={secondaryAction}
            title={i18n.t('emcShared.global.modal.redeclare.actions.primary')}
            className="w-full"
          />
          <Button
            variant="primary"
            onClick={handleRedeclare}
            title={i18n.t('emcShared.global.modal.redeclare.actions.secondary')}
            className="w-full"
          />
        </div>
      }
    />
  );
};
